import { Col, Divider, Row, Tag, Tooltip, Typography } from 'antd'
import React from 'react'
import { EditIcon, NoExperienceIcon } from '../../../assets/icons'
import NoIndividualContent from '../../profile/tabSection/noIndividualContent'
import OtherForm from './candidate-other-form'
const { Title, Text } = Typography

const CandidateOtherDetails = ({ activeTab,
    candidateId,
    showForm,
    setShowForm, currantData }) => {
    return (
        <div>
            <div style={{ marginTop: '15px' }}>
                {!showForm && (

                    <div>

                        <div style={{ display: 'flex', alignItems: 'center' }}>
                            <Title level={4}>Other Details</Title>
                            <Tooltip title="Edit Other Details">
                                <button
                                    style={{
                                        width: '26px',
                                        height: '26px',
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        marginLeft: '10px',
                                        borderRadius: '50%',
                                        border: 'none',
                                    }}
                                    onClick={() => setShowForm(true)}
                                >
                                    <EditIcon width={"25px"}
                                        style={{ fontSize: '15px' }}
                                    />
                                </button>
                            </Tooltip>
                        </div>
                        {currantData?.length === 0 ?
                            <NoIndividualContent
                                content={{
                                    key: 'projects',
                                    title: 'Projects',
                                    icon: <NoExperienceIcon />,
                                }}
                            /> : <div style={{ marginTop: '15px' }}>
                                {

                                    <Row gutter={25} >

                                        <Col
                                            xs={20}
                                            sm={20}
                                            md={20}
                                            lg={20}
                                            xl={20}
                                        >



                                            <div>
                                                {currantData?.hobbies
                                                    ?.length > 0 && (
                                                        <>
                                                            <div
                                                                style={{
                                                                    marginTop:
                                                                        '15px',
                                                                }}
                                                            >
                                                                <div>
                                                                    <Text
                                                                        style={{
                                                                            fontSize:
                                                                                '18px',
                                                                        }}
                                                                    >
                                                                        Hobbies

                                                                    </Text>
                                                                </div>
                                                            </div>
                                                            <Row gutter={10}>
                                                                {currantData?.hobbies.map(
                                                                    (
                                                                        data,
                                                                        index
                                                                    ) => {
                                                                        return (
                                                                            <Tag
                                                                                key={
                                                                                    index
                                                                                }
                                                                                bordered={
                                                                                    false
                                                                                }
                                                                                color="processing"
                                                                                style={{
                                                                                    marginTop:
                                                                                        '10px',
                                                                                }}
                                                                            >
                                                                                {
                                                                                    data

                                                                                }
                                                                            </Tag>
                                                                        )
                                                                    }
                                                                )}
                                                            </Row>
                                                        </>
                                                    )}
                                            </div>
                                        </Col>
                                        <Divider />
                                    </Row>


                                }

                            </div>
                        }
                    </div>
                )}
            </div>{
                showForm &&
                <OtherForm />
            }
        </div>
    )
}

export default CandidateOtherDetails
